"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResponsiveContext = exports.ResponsiveContext = void 0;
exports.ResponsiveContextProvider = ResponsiveContextProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const Helper_1 = require("../Helper");
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
exports.ResponsiveContext = react_1.default.createContext({
    size: "sm",
    columns: 1,
    width: 0,
    twoPercentOfScreen: 0,
    fourPercentOfScreen: 0,
    sixPercentOfScreen: 0,
    tenPercentOfScreen: 0,
    twelvePercentOfScreen: 0
});
function ResponsiveContextProvider(props) {
    const resizer = react_1.default.useRef(null);
    const getSizing = () => {
        const w = react_native_1.Dimensions.get('window').width;
        if (w >= 1920 && Helper_1.Helper.isPlatformWeb)
            return { size: 'xl', columns: 3 };
        if (w >= 1280 && Helper_1.Helper.isPlatformWeb)
            return { size: 'lg', columns: 2 };
        if (w >= 1024 && Helper_1.Helper.isPlatformWeb)
            return { size: 'md', columns: 2 };
        if (w >= 1024 && react_native_device_info_1.default.isTablet())
            return { size: 'md', columns: 2 };
        if (w >= 800 && Helper_1.Helper.isPlatformWeb)
            return { size: 'sm', columns: 2 };
        if (w >= 640 && Helper_1.Helper.isPlatformWeb)
            return { size: 'sm', columns: 2 };
        return { size: 'sm', columns: 1 };
    };
    const s = getSizing();
    const [size, setSize] = (0, react_1.useState)(s.size);
    const [columns, setColumns] = (0, react_1.useState)(s.columns);
    const [width, setWidth] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width);
    const [twoPercentOfScreen, setTwoPercentOfScreen] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width * 0.02);
    const [fourPercentOfScreen, setFourPercentOfScreen] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width * 0.04);
    const [sixPercentOfScreen, setSixPercentOfScreen] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width * 0.06);
    const [tenPercentOfScreen, setTenPercentOfScreen] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width * 0.1);
    const [twelvePercentOfScreen, setTwelvePercentOfScreen] = (0, react_1.useState)(react_native_1.Dimensions.get('window').width * 0.12);
    react_1.default.useEffect(() => {
        if (react_native_1.Platform.OS == 'web') {
            resizer.current = new ResizeObserver(() => {
                const s = getSizing();
                setSize(s.size);
                setColumns(s.columns);
                setWidth(react_native_1.Dimensions.get('window').width);
                setTwoPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.02);
                setFourPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.04);
                setSixPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.06);
                setTenPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.1);
                setTwelvePercentOfScreen(react_native_1.Dimensions.get('window').width * 0.12);
            });
            resizer.current.observe(document.body);
            return () => {
                resizer.current?.unobserve?.(document.body);
                resizer.current?.disconnect?.();
            };
        }
        else {
            const handler = () => {
                const s = getSizing();
                setSize(s.size);
                setColumns(s.columns);
                setWidth(react_native_1.Dimensions.get('window').width);
                setTwoPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.02);
                setFourPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.04);
                setSixPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.06);
                setTenPercentOfScreen(react_native_1.Dimensions.get('window').width * 0.1);
                setTwelvePercentOfScreen(react_native_1.Dimensions.get('window').width * 0.12);
            };
            const subscription = react_native_1.Dimensions.addEventListener('change', handler);
            return () => {
                subscription?.remove();
            };
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.ResponsiveContext.Provider, { value: {
            size,
            columns,
            width,
            twoPercentOfScreen,
            fourPercentOfScreen,
            sixPercentOfScreen,
            tenPercentOfScreen,
            twelvePercentOfScreen
        }, children: props.children }));
}
;
const useResponsiveContext = () => react_1.default.useContext(exports.ResponsiveContext);
exports.useResponsiveContext = useResponsiveContext;
